<template>
  <AppModal v-model="isOpen" @save="handleSave" @cancel="handleCancel" :show-save="false" :show-cancel="false">
    <div class="flex flex-col gap-4">
      <h2 class="text-2xl font-bold text-normal-emphasis">Rename hand</h2>
      
      <div class="flex flex-col gap-2">
        <label class="font-medium text-normal-emphasis">
          Hand name <span class="text-red-500">*</span>
        </label>
        <input 
          v-model="handName" 
          type="text" 
          placeholder="Example" 
          class="w-full p-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>
      
      <div class="flex flex-col gap-4 mt-4">
        <AppButton 
          title="Done" 
          :disabled="!handName.trim()" 
          @click="handleSave"
        />
        <AppCancel @click="handleCancel" />
      </div>
    </div>
  </AppModal>
</template>

<script setup lang="ts">
import { ref, defineEmits, defineProps, watch } from 'vue';
import AppModal from '@/components/AppModal.vue';
import AppButton from '@/components/AppButton.vue';
import AppCancel from '@/components/AppCancel.vue';

interface Props {
  modelValue: boolean;
  initialName?: string;
}

const props = defineProps<Props>();
const emit = defineEmits(['update:modelValue', 'save', 'cancel']);

const isOpen = ref(props.modelValue);
const handName = ref(props.initialName || '');

// Watch for changes in the modelValue prop
watch(() => props.modelValue, (newValue) => {
  isOpen.value = newValue;
});

// Watch for changes in the isOpen ref
watch(isOpen, (newValue) => {
  emit('update:modelValue', newValue);
});

// Watch for changes in the initialName prop
watch(() => props.initialName, (newValue) => {
  handName.value = newValue || '';
});

const handleSave = () => {
  if (handName.value.trim()) {
    emit('save', handName.value);
    isOpen.value = false;
  }
};

const handleCancel = () => {
  emit('cancel');
  isOpen.value = false;
};
</script>
